import React from 'react';
import errorMessageIcon from '../../assets/img/empty_state_icon.svg';
import './MapError.scss';

export const MapError: React.FC<{ error: Error }> = () => {
  return (
    <div id="map-error">
      <div data-testid="map-error-view" className="vertical-center">
         <img src={errorMessageIcon} alt="Something went wrong. The map can't be displayed" data-testid="map-error-icon" />
      </div>
    </div>
  );
};
